import type { AnalyticsDestination } from "../analytics";
import { SGTM_ENDPOINT_URL } from "../config.ts";
import { hasAnalyticsConsent } from "../consent/readStoredGcmConsent.ts";

export const sgtmDestination: AnalyticsDestination = {
  name: "sgtm",
  async push(event) {
    // Read per event: the user can grant or withdraw consent mid-session.
    if (!SGTM_ENDPOINT_URL || !event.tid || !hasAnalyticsConsent()) return;
    try {
      await fetch(SGTM_ENDPOINT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify(event),
        keepalive: true,
        credentials: "include",
      });
    } catch {
      // swallow analytics errors
    }
  },
};
